export default __webpack_public_path__ + "static/media/anexo.fa11122d.svg";